import { themeVariables } from "Components/theme";
import chroma from "chroma-js";
import { Theme, VoidPortStyle, WebGL2IconNodeStyle } from "yfiles";
import buildStroke from "./buildStroke";
import initializeDefaultNodeStyles from "./initializeDefaultNodeStyles";
import RenderingManager from "./renderingManager";
import webGL2EdgeStyles from "./webGL2EdgeStyles";
import webGL2NodeStyles from "./webGL2NodeStyles";
export default async (graphComponent, showNamesRef) => {
    if (!(graphComponent === null || graphComponent === void 0 ? void 0 : graphComponent.graph))
        return undefined;
    await initializeDefaultNodeStyles(webGL2NodeStyles);
    const renderingManager = new RenderingManager(graphComponent, (node, selected) => {
        const tag = node.tag;
        const nodeId = tag === null || tag === void 0 ? void 0 : tag.Id;
        const icon = tag === null || tag === void 0 ? void 0 : tag.Icon;
        const color = tag === null || tag === void 0 ? void 0 : tag.Color;
        const showNames = showNamesRef.current;
        const iconIdColorMap = icon && webGL2NodeStyles.iconIdMap[icon]
            ? webGL2NodeStyles.iconIdMap[icon]
            : webGL2NodeStyles.iconIdMap._default;
        if (!showNames) {
            if (!color) {
                if (!selected)
                    return iconIdColorMap._default;
                if (!iconIdColorMap._defaultSelected)
                    iconIdColorMap._defaultSelected = new WebGL2IconNodeStyle({
                        icon: iconIdColorMap._default.icon,
                        shape: iconIdColorMap._default.shape,
                        fill: themeVariables["brand-primary-200"],
                        stroke: buildStroke(themeVariables["brand-primary-500"], selected),
                        effect: iconIdColorMap._default.effect,
                        preserveAspectRatio: iconIdColorMap._default.preserveAspectRatio
                    });
                return iconIdColorMap._defaultSelected;
            }
            const colorMapKey = !selected ? color : `${color}Selected`;
            if (iconIdColorMap[colorMapKey])
                return iconIdColorMap[colorMapKey];
            iconIdColorMap[colorMapKey] = new WebGL2IconNodeStyle({
                icon: iconIdColorMap._default.icon,
                shape: iconIdColorMap._default.shape,
                fill: chroma(color)
                    .set("hsl.l", selected ? 0.65 : 0.9)
                    .css(),
                stroke: buildStroke(color, selected),
                effect: iconIdColorMap._default.effect,
                preserveAspectRatio: iconIdColorMap._default.preserveAspectRatio
            });
            return iconIdColorMap[colorMapKey];
        }
        const style = nodeId && webGL2NodeStyles.nodeIdMap[nodeId]
            ? webGL2NodeStyles.nodeIdMap[nodeId]._default
            : undefined;
        if (!style) {
            return iconIdColorMap._default;
        }
        return color
            ? new WebGL2IconNodeStyle({
                icon: style.icon,
                shape: style.shape,
                fill: chroma(color)
                    .set("hsl.l", selected ? 0.65 : 0.9)
                    .css(),
                stroke: buildStroke(color, selected),
                effect: style.effect,
                preserveAspectRatio: style.preserveAspectRatio
            })
            : style;
    }, (_, selected) => !selected ? webGL2EdgeStyles.default : webGL2EdgeStyles.defaultSelected, null);
    graphComponent.graph.nodeDefaults.shareStyleInstance = false;
    graphComponent.graph.edgeDefaults.shareStyleInstance = false;
    const theme = new Theme({
        variant: "simple-round",
        primaryColor: themeVariables["brand-primary-500"],
        backgroundColor: "#ffffff"
    });
    graphComponent.theme = theme;
    graphComponent.graph.edgeDefaults.ports.shareStyleInstance = true;
    graphComponent.graph.edgeDefaults.ports.style = VoidPortStyle.INSTANCE;
    graphComponent.graph.nodeDefaults.ports.shareStyleInstance = true;
    graphComponent.graph.nodeDefaults.ports.style = VoidPortStyle.INSTANCE;
    return renderingManager;
};
